// import React, { useState } from 'react';
// import './loginstyle.css';
// import { URL } from '../../config';

// const ForgetPassword = ({ onClose }) => {
//     const [email, setEmail] = useState('');
//     const [role, setRole] = useState('user');
//     const [errMsg, setErrMsg] = useState('');
//     const [otpSent, setOtpSent] = useState(false);
//     const [otp, setOtp] = useState('');
//     const [otpVerified, setOtpVerified] = useState(false);
//     const [newPassword, setNewPassword] = useState('');
//     const [confirmPassword, setConfirmPassword] = useState('');

//     const handleRoleChange = (event) => {
//         setRole(event.target.value);
//     };

//     const handleSendOtp = async () => {
//         try {
//             const response = await fetch(`${URL}/forgot-password`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({ email, role })
//             });

//             if (response.ok) {
//                 setOtpSent(true);
//                 setErrMsg('');
//             } else {
//                 const error = await response.json();
//                 setErrMsg(error.message);
//             }
//         } catch (error) {
//             setErrMsg('Failed to send OTP');
//         }
//     };

//     const handleVerifyOtp = async () => {
//         try {
//             const response = await fetch(`${URL}/verify-forgot-password-otp`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({ email, otp })
//             });

//             if (response.ok) {
//                 setOtpVerified(true);
//                 setErrMsg('');
//             } else {
//                 const error = await response.json();
//                 setErrMsg(error.message);
//             }
//         } catch (error) {
//             setErrMsg('Failed to verify OTP');
//         }
//     };

//     const handleChangePassword = async () => {
//         if (newPassword !== confirmPassword) {
//             setErrMsg('Passwords do not match');
//             return;
//         }

//         try {
//             const response = await fetch(`${URL}/reset-password`, {
//                 method: 'POST',
//                 headers: {
//                     'Content-Type': 'application/json'
//                 },
//                 body: JSON.stringify({ email, newPassword })
//             });

//             if (response.ok) {
//                 setErrMsg('');
//                 onClose();
//             } else {
//                 const error = await response.json();
//                 setErrMsg(error.message);
//             }
//         } catch (error) {
//             setErrMsg('Failed to reset password');
//         }
//     };

//     return (
//         <div className="forgot-password-overlay">
//             <div className="forgot-password-card">
//                 {otpVerified ? (
//                     <>
//                         <h2 className="text-left">Reset Password</h2>
//                         <hr />
//                         <input
//                             type="password"
//                             className="otp-input"
//                             placeholder="New Password"
//                             value={newPassword}
//                             onChange={(e) => setNewPassword(e.target.value)}
//                         />
//                         <input
//                             type="password"
//                             className="otp-input"
//                             placeholder="Confirm Password"
//                             value={confirmPassword}
//                             onChange={(e) => setConfirmPassword(e.target.value)}
//                         />
//                         {errMsg && <div className="error-message">{errMsg}</div>}
//                         <button className="otp-button" onClick={handleChangePassword}>Change Password</button>
//                         <button className="otp-button" onClick={onClose}>Cancel</button>
//                     </>
//                 ) : otpSent ? (
//                     <>
//                         <h2 className="text-left">Verify OTP</h2>
//                         <hr />
//                         <p>We sent an OTP to {email}. Please enter it below.</p>
//                         <input
//                             type="text"
//                             className="otp-input"
//                             placeholder="Enter OTP"
//                             value={otp}
//                             onChange={(e) => setOtp(e.target.value)}
//                         />
//                         {errMsg && <div className="error-message">{errMsg}</div>}
//                         <button className="otp-button" onClick={handleVerifyOtp}>Verify OTP</button>
//                         <button className="otp-button" onClick={onClose}>Cancel</button>
//                     </>
//                 ) : (
//                     <>
//                         <h2 className="text-left">Forgot Password</h2>
//                         <hr />
//                         <p>Enter a valid email. We will send an OTP to your email for password reset.</p>
//                         <input
//                             type="email"
//                             className="otp-input"
//                             placeholder="Email"
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                         />
//                         <div>
//                             <label>
//                                 <input
//                                     type="radio"
//                                     value="user"
//                                     checked={role === 'user'}
//                                     onChange={handleRoleChange}
//                                 />
//                                 User
//                             </label>
//                             <label>
//                                 <input
//                                     type="radio"
//                                     value="servitor"
//                                     checked={role === 'servitor'}
//                                     onChange={handleRoleChange}
//                                 />
//                                 Servitor
//                             </label>
//                         </div>
//                         {errMsg && <div className="error-message">{errMsg}</div>}
//                         <button className="otp-button" onClick={handleSendOtp}>Send OTP</button>
//                         <button className="otp-button" onClick={onClose}>Cancel</button>
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// };

// export default ForgetPassword;

// *** Upper code all is working fine and perfect - last checked (18-6-25) *** //



// ***** Added code new Translate EN-BN - Updated (18-6-25) ***** //

// import React, { useState } from "react";
// import "./loginstyle.css";
// import { URL } from "../../config";
// import { useTranslation, Trans } from "react-i18next";

// const ForgetPassword = ({ onClose }) => {
//   const { t, i18n } = useTranslation();

//   const [email, setEmail] = useState("");
//   const [role, setRole] = useState("user");
//   const [errMsg, setErrMsg] = useState("");
//   const [otpSent, setOtpSent] = useState(false);
//   const [otp, setOtp] = useState("");
//   const [otpVerified, setOtpVerified] = useState(false);
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");

//   const handleRoleChange = (event) => {
//     setRole(event.target.value);
//   };

//   const handleSendOtp = async () => {
//     try {
//       const response = await fetch(`${URL}/forgot-password`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, role }),
//       });

//       if (response.ok) {
//         setOtpSent(true);
//         setErrMsg("");
//       } else {
//         const error = await response.json();
//         // setErrMsg(error.message);
//         const errorMessage =
//           error.message || error.error || "Failed to send OTP";
//         const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
//         const translatedError =
//           i18n.language === "bn"
//             ? t(`forgot_password.error_messages.${errorKey}`, {
//                 defaultValue: errorMessage,
//               })
//             : errorMessage;
//         setErrMsg(translatedError);
//       }
//     } catch (error) {
//       // setErrMsg('Failed to send OTP');
//       setErrMsg(t("forgot_password.error_messages.internal_server_error"));
//     }
//   };

//   const handleVerifyOtp = async () => {
//     try {
//       const response = await fetch(`${URL}/verify-forgot-password-otp`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, otp }),
//       });

//       if (response.ok) {
//         setOtpVerified(true);
//         setErrMsg("");
//       } else {
//         const error = await response.json();
//         // setErrMsg(error.message);
//         const errorMessage = error.message || "Invalid OTP";
//         const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
//         const translatedError =
//           i18n.language === "bn"
//             ? t(`forgot_password.error_messages.${errorKey}`, {
//                 defaultValue: errorMessage,
//               })
//             : errorMessage;
//         setErrMsg(translatedError);
//       }
//     } catch (error) {
//       // setErrMsg('Failed to verify OTP');
//       setErrMsg(t("forgot_password.error_messages.internal_server_error"));
//     }
//   };

//   const handleChangePassword = async () => {
//     if (newPassword !== confirmPassword) {
//       // setErrMsg('Passwords do not match');
//       setErrMsg(t("forgot_password.error_messages.password_mismatch"));
//       return;
//     }

//     try {
//       const response = await fetch(`${URL}/reset-password`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, newPassword }),
//       });

//       if (response.ok) {
//         setErrMsg("");
//         onClose();
//       } else {
//         const error = await response.json();
//         // setErrMsg(error.message);
//         const errorMessage =
//           error.message || error.error || "Failed to reset password";
//         const errorKey = errorMessage.toLowerCase().replace(/\s+/g, "_");
//         const translatedError =
//           i18n.language === "bn"
//             ? t(`forgot_password.error_messages.${errorKey}`, {
//                 defaultValue: errorMessage,
//               })
//             : errorMessage;
//         setErrMsg(translatedError);
//       }
//     } catch (error) {
//       // setErrMsg('Failed to reset password');
//       setErrMsg(t("forgot_password.error_messages.internal_server_error"));
//     }
//   };

//   return (
//     <div className="forgot-password-overlay">
//       <div className="forgot-password-card">
//         {otpVerified ? (
//           <>
//             {/* <h2 className="text-left">Reset Password</h2> */}
//             <h2 className="text-left">{t("forgot_password.header_reset")}</h2>
//             <hr />
//             <input
//               type="password"
//               className="otp-input"
//               // placeholder="New Password"
//               placeholder={t("forgot_password.new_password_placeholder")}
//               value={newPassword}
//               onChange={(e) => setNewPassword(e.target.value)}
//             />
//             <input
//               type="password"
//               className="otp-input"
//               // placeholder="Confirm Password"
//               placeholder={t("forgot_password.confirm_password_placeholder")}
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//             />
//             {errMsg && <div className="error-message">{errMsg}</div>}
//             <button className="otp-button" onClick={handleChangePassword}>
//               {/* Change Password */}
//               {t("forgot_password.change_password_button")}
//             </button>
//             <button className="otp-button" onClick={onClose}>
//               Cancel
//             </button>
//           </>
//         ) : otpSent ? (
//           <>
//             {/* <h2 className="text-left">Verify OTP</h2> */}
//             <h2 className="text-left">{t("forgot_password.header_verify")}</h2>

//             <hr />
//             {/* <p>We sent an OTP to {email}. Please enter it below.</p> */}
//             {/* <p>{t("forgot_password.otp_message", { email })}</p> */}
//             <Trans
//               i18nKey="forgot_password.otp_message"
//               values={{ email }}
//               components={[<strong key="1" />]}
//             />

//             <input
//               type="text"
//               className="otp-input"
//               // placeholder="Enter OTP"
//               placeholder={t("forgot_password.otp_placeholder")}
//               value={otp}
//               onChange={(e) => setOtp(e.target.value)}
//             />
//             {errMsg && <div className="error-message">{errMsg}</div>}
//             <button className="otp-button" onClick={handleVerifyOtp}>
//               {/* Verify OTP */}
//               {t("forgot_password.verify_otp_button")}
//             </button>
//             <button className="otp-button" onClick={onClose}>
//               {/* Cancel */}
//               {t("forgot_password.cancel_button")}
//             </button>
//           </>
//         ) : (
//           <>
//             <h2 className="text-left">
//               {/* Forgot Password */}
//               {t("forgot_password.header_forgot")}
//             </h2>
//             <hr />
//             {/* <p>Enter a valid email. We will send an OTP to your email for password reset.</p> */}
//             <p>{t("forgot_password.email_instruction")}</p>

//             <input
//               type="email"
//               className="otp-input"
//               // placeholder="Email"
//               placeholder={t("forgot_password.email_placeholder")}
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//             />
//             <div className="radio-group forgot-radio-group">
//               <label>
//                 <input
//                   type="radio"
//                   value="user"
//                   checked={role === "user"}
//                   onChange={handleRoleChange}
//                 />
//                 {/* User */}
//                 {t("forgot_password.user_label")}
//               </label>
//               <label>
//                 <input
//                   type="radio"
//                   value="servitor"
//                   checked={role === "servitor"}
//                   onChange={handleRoleChange}
//                 />
//                 {/* Servitor */}
//                 {t("forgot_password.servitor_label")}
//               </label>
//             </div>
//             {errMsg && <div className="error-message">{errMsg}</div>}
//             <button className="otp-button" onClick={handleSendOtp}>
//               {/* Send OTP */}
//               {t("forgot_password.send_otp_button")}
//             </button>
//             <button className="otp-button" onClick={onClose}>
//               {/* Cancel */}
//               {t("forgot_password.cancel_button")}
//             </button>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ForgetPassword;















// import React, { useEffect, useState } from "react";
// import "./forgotpassword.css";   // updated styles below
// import "./signupstyle.css"; // reuse existing OTP modal styles
// import { URL } from "../../config";
// import { useTranslation } from "react-i18next";

// const BD_MOBILE_REGEX = /^01[3-9]\d{8}$/;

// const ForgetPassword = ({ onClose }) => {
//   const { t } = useTranslation();

//   // form
//   const [role, setRole] = useState("user");
//   const [mobile, setMobile] = useState("");
//   const [errMsg, setErrMsg] = useState("");

//   // OTP flow
//   const [showOtp, setShowOtp] = useState(false);
//   const [otpId, setOtpId] = useState(null);
//   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
//   const [otpErr, setOtpErr] = useState("");
//   const [otpSeconds, setOtpSeconds] = useState(60);
//   const [sendingOtp, setSendingOtp] = useState(false);
//   const [verifyingOtp, setVerifyingOtp] = useState(false);
//   const [otpVerified, setOtpVerified] = useState(false);

//   // new password UI
//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [showPass1, setShowPass1] = useState(false);
//   const [showPass2, setShowPass2] = useState(false);
//   const [changingPass, setChangingPass] = useState(false);

//   // success modal
//   const [showSuccess, setShowSuccess] = useState(false);
//   const [successSeconds, setSuccessSeconds] = useState(3);

//   // OTP countdown
//   useEffect(() => {
//     if (!showOtp) return;
//     const timer = setInterval(() => {
//       setOtpSeconds((s) => (s > 0 ? s - 1 : 0));
//     }, 1000);
//     return () => clearInterval(timer);
//   }, [showOtp]);

//   // success auto-close
//   useEffect(() => {
//     if (!showSuccess) return;
//     setSuccessSeconds(3);
//     const iv = setInterval(() => {
//       setSuccessSeconds((s) => {
//         if (s <= 1) {
//           clearInterval(iv);
//           onClose?.();
//           return 0;
//         }
//         return s - 1;
//       });
//     }, 1000);
//     return () => clearInterval(iv);
//   }, [showSuccess, onClose]);

//   const handleRoleChange = (e) => setRole(e.target.value);

//   const handleSendOtp = async () => {
//     try {
//       setErrMsg("");
//       if (!BD_MOBILE_REGEX.test(mobile)) {
//         setErrMsg(
//           t("forgot_password.error_messages.invalid_mobile") ||
//             "Enter a valid mobile number (01XXXXXXXXX)."
//         );
//         return;
//       }

//       // 1) must be an existing account for that role
//       const preRes = await fetch(`${URL}/password/forgot/mobile/precheck`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ role, mobile }),
//       });
//       if (!preRes.ok) {
//         const body = await preRes.json().catch(() => ({}));
//         setErrMsg(body?.error || body?.message || "Account not found");
//         return;
//       }

//       // 2) start OTP (server logs the code to console for now)
//       setSendingOtp(true);
//       const startRes = await fetch(`${URL}/otp/start`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ mobile }),
//       });
//       const data = await startRes.json();

//       if (!startRes.ok) {
//         if (startRes.status === 429 && data?.retryAfter != null) {
//           setErrMsg(
//             `${t("forgot_password.please_wait") || "Please wait"} ${
//               data.retryAfter
//             }s ${t("forgot_password.before_retry") || "before requesting another code."}`
//           );
//         } else {
//           setErrMsg(data?.error || "Failed to send OTP");
//         }
//         return;
//       }

//       setOtpId(data.otpId);
//       setOtpDigits(["", "", "", "", "", ""]);
//       setOtpErr("");
//       setShowOtp(true);
//       setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);
//       setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
//     } catch {
//       setErrMsg(
//         t("forgot_password.error_messages.internal_server_error") ||
//           "Internal server error"
//       );
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   // OTP input handlers
//   const handleOtpChange = (e, index) => {
//     const value = e.target.value.replace(/\D/g, "").slice(0, 1);
//     const next = [...otpDigits];
//     next[index] = value;
//     setOtpDigits(next);

//     if (value && index < 5) {
//       document.querySelector(`input[data-index="${index + 1}"]`)?.focus();
//     }
//     if (next.every((d) => d.length === 1)) verifyOtp(next.join(""));
//   };
//   const handleOtpKeyDown = (e, index) => {
//     if (e.key === "Backspace") {
//       e.preventDefault();
//       const next = [...otpDigits];
//       if (next[index]) {
//         next[index] = "";
//         setOtpDigits(next);
//       } else if (index > 0) {
//         next[index - 1] = "";
//         setOtpDigits(next);
//         document.querySelector(`input[data-index="${index - 1}"]`)?.focus();
//       }
//     }
//   };
//   const handleOtpPaste = (e, index) => {
//     e.preventDefault();
//     const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
//     if (!pasted) return;
//     const next = [...otpDigits];
//     pasted.split("").forEach((c, i) => {
//       if (index + i < 6) next[index + i] = c;
//     });
//     setOtpDigits(next);
//     const focusIndex = Math.min(index + pasted.length - 1, 5);
//     document.querySelector(`input[data-index="${focusIndex}"]`)?.focus();
//     if (next.every((d) => d)) verifyOtp(next.join(""));
//   };

//   const verifyOtp = async (code) => {
//     if ((code || "").length !== 6) {
//       setOtpErr(t("forgot_password.otp_enter_code") || "Enter the 6-digit code.");
//       return;
//     }
//     setVerifyingOtp(true);
//     try {
//       const res = await fetch(`${URL}/otp/verify`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ otpId, code, purpose: "reset" }),
//       });
//       const data = await res.json().catch(() => ({}));
//       if (!res.ok) {
//         setOtpErr(data?.error || "Invalid or expired code.");
//         setOtpDigits(["", "", "", "", "", ""]);
//         setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
//         return;
//       }
//       setOtpVerified(true);
//       setShowOtp(false);
//       setOtpErr("");
//     } catch {
//       setOtpErr(
//         t("forgot_password.error_messages.internal_server_error") ||
//           "Internal server error"
//       );
//     } finally {
//       setVerifyingOtp(false);
//     }
//   };

//   const resendOtp = async () => {
//     if (otpSeconds > 0) return;
//     try {
//       setSendingOtp(true);
//       const res = await fetch(`${URL}/otp/start`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ mobile }),
//       });
//       const data = await res.json();
//       if (!res.ok) {
//         setOtpErr(data?.error || "Failed to resend code.");
//         return;
//       }
//       setOtpId(data.otpId);
//       setOtpDigits(["", "", "", "", "", ""]);
//       setOtpErr("");
//       setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);
//       setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
//     } catch {
//       setOtpErr(
//         t("forgot_password.error_messages.internal_server_error") ||
//           "Internal server error"
//       );
//     } finally {
//       setSendingOtp(false);
//     }
//   };

//   const handleChangePassword = async () => {
//     if (!newPassword || !confirmPassword) {
//       setErrMsg(
//         t("forgot_password.error_messages.required") ||
//           "Please fill in both password fields."
//       );
//       return;
//     }
//     if (newPassword !== confirmPassword) {
//       setErrMsg(
//         t("forgot_password.error_messages.password_mismatch") ||
//           "Passwords do not match"
//       );
//       return;
//     }
//     try {
//       setChangingPass(true);
//       const res = await fetch(`${URL}/password/reset/mobile`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ role, mobile, newPassword }),
//       });
//       const data = await res.json().catch(() => ({}));
//       if (!res.ok) {
//         setErrMsg(data?.error || data?.message || "Failed to reset password");
//         return;
//       }
//       setErrMsg("");
//       setShowSuccess(true);
//     } catch {
//       setErrMsg(
//         t("forgot_password.error_messages.internal_server_error") ||
//           "Internal server error"
//       );
//     } finally {
//       setChangingPass(false);
//     }
//   };

//   return (
//     <>
//       {/* Card */}
//       <div className="fp-overlay">
//         <div className="fp-card">
//           {!otpVerified ? (
//             <>
//               <div className="fp-header">
//                 <h2>{t("forgot_password.header_forgot") || "Forgot Password"}</h2>
//                 <p className="fp-desc">
//                   {t("forgot_password.mobile_instruction") ||
//                     "Enter your registered mobile number. We'll send a 6-digit code to verify it's you."}
//                 </p>
//               </div>

//               {/* Mobile field with icon */}
//               <div className="fp-field">
//                 <span className="fp-icon" aria-hidden>
//                   {/* phone icon */}
//                   <svg viewBox="0 0 24 24" fill="none">
//                     <path
//                       d="M3 5a2 2 0 012-2h3.3a1 1 0 01.95.68l1.5 4.49a1 1 0 01-.5 1.21l-2.26 1.13a11.04 11.04 0 005.52 5.52l1.13-2.26a1 1 0 011.21-.5l4.49 1.5c.4.13.67.5.68.95V19a2 2 0 01-2 2h-1C9.72 21 3 14.28 3 6V5z"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </span>
//                 <input
//                   type="tel"
//                   inputMode="numeric"
//                   maxLength={11}
//                   className="fp-input"
//                   placeholder={t("forgot_password.mobile_placeholder") || "01XXXXXXXXX"}
//                   value={mobile}
//                   onChange={(e) =>
//                     setMobile(e.target.value.replace(/\D/g, "").slice(0, 11))
//                   }
//                 />
//               </div>

//               {/* Roles */}
//               <div className="fp-roles">
//                 <label className={`fp-radio ${role === "user" ? "is-checked" : ""}`}>
//                   <span className="fp-dot" />
//                   <input
//                     type="radio"
//                     value="user"
//                     checked={role === "user"}
//                     onChange={handleRoleChange}
//                   />
//                   <span className="fp-radio-label">
//                     {t("forgot_password.user_label") || "User"}
//                   </span>
//                 </label>

//                 <label
//                   className={`fp-radio ${role === "servitor" ? "is-checked" : ""}`}
//                 >
//                   <span className="fp-dot" />
//                   <input
//                     type="radio"
//                     value="servitor"
//                     checked={role === "servitor"}
//                     onChange={handleRoleChange}
//                   />
//                   <span className="fp-radio-label">
//                     {t("forgot_password.servitor_label") || "Servitor"}
//                   </span>
//                 </label>
//               </div>

//               {errMsg && <div className="fp-error">{errMsg}</div>}

//               <div className="fp-actions">
//                 <button
//                   className="fp-btn fp-btn--primary"
//                   onClick={handleSendOtp}
//                   disabled={sendingOtp || showOtp}
//                 >
//                   {sendingOtp
//                     ? t("forgot_password.sending") || "Sending..."
//                     : t("forgot_password.send_otp_button") || "Send OTP"}
//                 </button>
//                 <button className="fp-btn fp-btn--ghost" onClick={onClose}>
//                   {t("forgot_password.cancel_button") || "Cancel"}
//                 </button>
//               </div>
//             </>
//           ) : (
//             <>
//               <div className="fp-header">
//                 <h2>{t("forgot_password.header_reset") || "Reset Password"}</h2>
//                 <p className="fp-desc">
//                   {t("forgot_password.reset_instruction") ||
//                     "Enter your new password below to complete the reset process."}
//                 </p>
//               </div>

//               {/* New password */}
//               <div className="fp-field">
//                 <span className="fp-icon" aria-hidden>
//                   {/* lock icon */}
//                   <svg viewBox="0 0 24 24" fill="none">
//                     <path
//                       d="M12 15v2M6 20h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zM16 10V7a4 4 0 10-8 0v3"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </span>
//                 <input
//                   type={showPass1 ? "text" : "password"}
//                   className="fp-input"
//                   placeholder={
//                     t("forgot_password.new_password_placeholder") || "New Password"
//                   }
//                   value={newPassword}
//                   onChange={(e) => setNewPassword(e.target.value)}
//                 />
//                 <button
//                   type="button"
//                   className="fp-eye"
//                   onClick={() => setShowPass1((v) => !v)}
//                   aria-label="Toggle password visibility"
//                 >
//                   <svg viewBox="0 0 24 24" fill="none">
//                     <path
//                       d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     />
//                     <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
//                   </svg>
//                 </button>
//               </div>

//               {/* Confirm password */}
//               <div className="fp-field">
//                 <span className="fp-icon" aria-hidden>
//                   <svg viewBox="0 0 24 24" fill="none">
//                     <path
//                       d="M12 15v2M6 20h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zM16 10V7a4 4 0 10-8 0v3"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                       strokeLinecap="round"
//                       strokeLinejoin="round"
//                     />
//                   </svg>
//                 </span>
//                 <input
//                   type={showPass2 ? "text" : "password"}
//                   className="fp-input"
//                   placeholder={
//                     t("forgot_password.confirm_password_placeholder") ||
//                     "Confirm Password"
//                   }
//                   value={confirmPassword}
//                   onChange={(e) => setConfirmPassword(e.target.value)}
//                 />
//                 <button
//                   type="button"
//                   className="fp-eye"
//                   onClick={() => setShowPass2((v) => !v)}
//                   aria-label="Toggle confirm password visibility"
//                 >
//                   <svg viewBox="0 0 24 24" fill="none">
//                     <path
//                       d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
//                       stroke="currentColor"
//                       strokeWidth="2"
//                     />
//                     <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
//                   </svg>
//                 </button>
//               </div>

//               {errMsg && <div className="fp-error">{errMsg}</div>}

//               <div className="fp-actions">
//                 <button
//                   className="fp-btn fp-btn--primary"
//                   onClick={handleChangePassword}
//                   disabled={changingPass}
//                 >
//                   {changingPass
//                     ? t("forgot_password.changing") || "Changing..."
//                     : t("forgot_password.change_password_button") ||
//                       "Change Password"}
//                 </button>
//                 <button className="fp-btn fp-btn--ghost" onClick={onClose}>
//                   {t("forgot_password.cancel_button") || "Cancel"}
//                 </button>
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* OTP Modal — unchanged, reuses your styles */}
//       {showOtp && (
//         <div className="servitorsignupotp-overlay">
//           <div className="servitorsignupotp-modal" onClick={(e) => e.stopPropagation()}>
//             <div className="servitorsignupotp-header">
//               <div className="servitorsignupotp-header-content">
//                 <div className="servitorsignupotp-icon-container">
//                   <div className="servitorsignupotp-icon-bg">
//                     <svg className="servitorsignupotp-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
//                     </svg>
//                   </div>
//                   <div className="servitorsignupotp-pulse-ring" />
//                 </div>
//                 <div>
//                   <h2 className="servitorsignupotp-title">
//                     {t("forgot_password.otp_title") || "Verify Your Phone"}
//                   </h2>
//                   <p className="servitorsignupotp-sub">
//                     {t("forgot_password.otp_sub", { mobile }) || `Enter the 6-digit code sent to ${mobile}`}
//                   </p>
//                 </div>
//               </div>
//               <button className="servitorsignupotp-close" onClick={() => setShowOtp(false)}>
//                 <svg className="servitorsignupotp-close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>

//             <div className="servitorsignupotp-body">
//               <div className="servitorsignupotp-input-section">
//                 <label className="servitorsignupotp-label">
//                   {t("forgot_password.otp_label") || "Verification Code"}
//                 </label>
//                 <div className="servitorsignupotp-inputs">
//                   {otpDigits.map((d, idx) => (
//                     <input
//                       key={idx}
//                       type="text"
//                       inputMode="numeric"
//                       autoComplete={idx === 0 ? "one-time-code" : undefined}
//                       maxLength="1"
//                       className="servitorsignupotp-input"
//                       value={d}
//                       onChange={(e) => handleOtpChange(e, idx)}
//                       onKeyDown={(e) => handleOtpKeyDown(e, idx)}
//                       onPaste={(e) => handleOtpPaste(e, idx)}
//                       onFocus={(e) => e.target.select()}
//                       autoFocus={idx === 0}
//                       data-index={idx}
//                       disabled={verifyingOtp || sendingOtp}
//                     />
//                   ))}
//                 </div>
//               </div>

//               {otpErr && <div className="servitorsignup-inline-error">{otpErr}</div>}

//               <div className="servitorsignupotp-timer-section">
//                 <div className="servitorsignupotp-timer-content">
//                   <svg className="servitorsignupotp-timer-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                   <span className="servitorsignupotp-timer-text">
//                     {otpSeconds > 0
//                       ? (t("forgot_password.otp_timer", { seconds: otpSeconds }) || `Resend code in ${otpSeconds}s`)
//                       : (t("forgot_password.otp_no_code") || "Didn't receive the code?")}
//                   </span>
//                 </div>
//                 {otpSeconds === 0 && (
//                   <button className="servitorsignupotp-resend" onClick={resendOtp} disabled={sendingOtp || verifyingOtp}>
//                     {t("forgot_password.otp_resend") || "Resend Code"}
//                   </button>
//                 )}
//               </div>

//               <div className="servitorsignupotp-actions">
//                 <button
//                   className="servitorsignupotp-verify-btn"
//                   onClick={() => verifyOtp(otpDigits.join(""))}
//                   disabled={verifyingOtp || sendingOtp || !otpDigits.every((d) => d.length === 1)}
//                 >
//                   {verifyingOtp
//                     ? t("forgot_password.otp_verifying") || "Verifying..."
//                     : t("forgot_password.otp_verify") || "Verify Code"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Success modal */}
//       {showSuccess && (
//         <div className="fp-success-overlay">
//           <div className="fp-success-card">
//             <div className="fp-success-icon">
//               <svg viewBox="0 0 24 24" fill="none">
//                 <path d="M5 13l4 4L19 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//               </svg>
//             </div>
//             <h3>{t("forgot_password.success_title") || "Password Reset Successfully!"}</h3>
//             <p className="fp-success-sub">
//               {t("forgot_password.success_sub") || "Your password has been updated. You can now sign in with your new password."}
//             </p>
//             <button className="fp-btn fp-btn--primary" onClick={onClose}>
//               {t("forgot_password.back_to_login") || "Back to Login"}
//             </button>

//              <p className="fp-countdown">
//               {t("forgot_password.redirect_in", { seconds: successSeconds }) || `Redirecting to login in ${successSeconds}s`}
//             </p>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ForgetPassword;




// ***** New Update (17-Dec-2025) ***** //

import React, { useEffect, useState } from "react";
import "./forgotpassword.css";   // updated styles below
import "./signupstyle.css"; // reuse existing OTP modal styles
import { URL } from "../../config";
import { useTranslation } from "react-i18next";

const BD_MOBILE_REGEX = /^01[3-9]\d{8}$/;

const ForgetPassword = ({ onClose }) => {
  const { t } = useTranslation();

  // form
  const [role, setRole] = useState("user");
  const [mobile, setMobile] = useState("");
  const [errMsg, setErrMsg] = useState("");

  // OTP flow
  const [showOtp, setShowOtp] = useState(false);
  const [otpId, setOtpId] = useState(null);
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [otpErr, setOtpErr] = useState("");
  const [otpSeconds, setOtpSeconds] = useState(60);
  const [sendingOtp, setSendingOtp] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  // new password UI
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPass1, setShowPass1] = useState(false);
  const [showPass2, setShowPass2] = useState(false);
  const [changingPass, setChangingPass] = useState(false);

  // success modal
  const [showSuccess, setShowSuccess] = useState(false);
  const [successSeconds, setSuccessSeconds] = useState(3);

  // OTP countdown
  useEffect(() => {
    if (!showOtp) return;
    const timer = setInterval(() => {
      setOtpSeconds((s) => (s > 0 ? s - 1 : 0));
    }, 1000);
    return () => clearInterval(timer);
  }, [showOtp]);

  // success auto-close
  useEffect(() => {
    if (!showSuccess) return;
    setSuccessSeconds(3);
    const iv = setInterval(() => {
      setSuccessSeconds((s) => {
        if (s <= 1) {
          clearInterval(iv);
          onClose?.();
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(iv);
  }, [showSuccess, onClose]);

  const handleRoleChange = (e) => setRole(e.target.value);

  const handleSendOtp = async () => {
    try {
      setErrMsg("");
      if (!BD_MOBILE_REGEX.test(mobile)) {
        setErrMsg(
          t("forgot_password.error_messages.invalid_mobile") ||
            "Enter a valid mobile number (01XXXXXXXXX)."
        );
        return;
      }

      // 1) must be an existing account for that role
      const preRes = await fetch(`${URL}/password/forgot/mobile/precheck`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role, mobile }),
      });
      if (!preRes.ok) {
        const body = await preRes.json().catch(() => ({}));
        setErrMsg(body?.error || body?.message || "Account not found");
        return;
      }

      // 2) start OTP (server logs the code to console for now)
      setSendingOtp(true);
      const startRes = await fetch(`${URL}/otp/start`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify({ mobile }),
        body: JSON.stringify({
          mobile,
          purpose: role === "user" ? "reset_user" : "reset_servitor"
        }),
      });
      const data = await startRes.json();

      if (!startRes.ok) {
        if (startRes.status === 429 && data?.retryAfter != null) {
          setErrMsg(
            `${t("forgot_password.please_wait") || "Please wait"} ${
              data.retryAfter
            }s ${t("forgot_password.before_retry") || "before requesting another code."}`
          );
        } else {
          setErrMsg(data?.error || "Failed to send OTP");
        }
        return;
      }

      setOtpId(data.otpId);
      setOtpDigits(["", "", "", "", "", ""]);
      setOtpErr("");
      setShowOtp(true);
      setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);
      setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
    } catch {
      setErrMsg(
        t("forgot_password.error_messages.internal_server_error") ||
          "Internal server error"
      );
    } finally {
      setSendingOtp(false);
    }
  };

  // OTP input handlers
  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 1);
    const next = [...otpDigits];
    next[index] = value;
    setOtpDigits(next);

    if (value && index < 5) {
      document.querySelector(`input[data-index="${index + 1}"]`)?.focus();
    }
    if (next.every((d) => d.length === 1)) verifyOtp(next.join(""));
  };
  const handleOtpKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const next = [...otpDigits];
      if (next[index]) {
        next[index] = "";
        setOtpDigits(next);
      } else if (index > 0) {
        next[index - 1] = "";
        setOtpDigits(next);
        document.querySelector(`input[data-index="${index - 1}"]`)?.focus();
      }
    }
  };
  const handleOtpPaste = (e, index) => {
    e.preventDefault();
    const pasted = e.clipboardData.getData("text").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;
    const next = [...otpDigits];
    pasted.split("").forEach((c, i) => {
      if (index + i < 6) next[index + i] = c;
    });
    setOtpDigits(next);
    const focusIndex = Math.min(index + pasted.length - 1, 5);
    document.querySelector(`input[data-index="${focusIndex}"]`)?.focus();
    if (next.every((d) => d)) verifyOtp(next.join(""));
  };

  const verifyOtp = async (code) => {
    if ((code || "").length !== 6) {
      setOtpErr(t("forgot_password.otp_enter_code") || "Enter the 6-digit code.");
      return;
    }
    setVerifyingOtp(true);
    try {
      const res = await fetch(`${URL}/otp/verify`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify({ otpId, code, purpose: "reset" }),
        body: JSON.stringify({
          otpId,
          code,
          purpose: role === "user" ? "reset_user" : "reset_servitor"
        }),

      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setOtpErr(data?.error || "Invalid or expired code.");
        setOtpDigits(["", "", "", "", "", ""]);
        setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
        return;
      }
      setOtpVerified(true);
      setShowOtp(false);
      setOtpErr("");
    } catch {
      setOtpErr(
        t("forgot_password.error_messages.internal_server_error") ||
          "Internal server error"
      );
    } finally {
      setVerifyingOtp(false);
    }
  };

  const resendOtp = async () => {
    if (otpSeconds > 0) return;
    try {
      setSendingOtp(true);
      const res = await fetch(`${URL}/otp/start`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        // body: JSON.stringify({ mobile }),
        body: JSON.stringify({
          mobile,
          purpose: role === "user" ? "reset_user" : "reset_servitor"
        }),
      });
      const data = await res.json();
      if (!res.ok) {
        setOtpErr(data?.error || "Failed to resend code.");
        return;
      }
      setOtpId(data.otpId);
      setOtpDigits(["", "", "", "", "", ""]);
      setOtpErr("");
      setOtpSeconds(typeof data.expiresIn === "number" ? data.expiresIn : 60);
      setTimeout(() => document.querySelector('input[data-index="0"]')?.focus(), 0);
    } catch {
      setOtpErr(
        t("forgot_password.error_messages.internal_server_error") ||
          "Internal server error"
      );
    } finally {
      setSendingOtp(false);
    }
  };

  const handleChangePassword = async () => {
    if (!newPassword || !confirmPassword) {
      setErrMsg(
        t("forgot_password.error_messages.required") ||
          "Please fill in both password fields."
      );
      return;
    }
    if (newPassword !== confirmPassword) {
      setErrMsg(
        t("forgot_password.error_messages.password_mismatch") ||
          "Passwords do not match"
      );
      return;
    }
    try {
      setChangingPass(true);
      const res = await fetch(`${URL}/password/reset/mobile`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ role, mobile, newPassword, otpId }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setErrMsg(data?.error || data?.message || "Failed to reset password");
        return;
      }
      setErrMsg("");
      setShowSuccess(true);
    } catch {
      setErrMsg(
        t("forgot_password.error_messages.internal_server_error") ||
          "Internal server error"
      );
    } finally {
      setChangingPass(false);
    }
  };

  return (
    <>
      {/* Card */}
      <div className="fp-overlay">
        <div className="fp-card">
          {!otpVerified ? (
            <>
              <div className="fp-header">
                <h2>{t("forgot_password.header_forgot") || "Forgot Password"}</h2>
                <p className="fp-desc">
                  {t("forgot_password.mobile_instruction") ||
                    "Enter your registered mobile number. We'll send a 6-digit code to verify it's you."}
                </p>
              </div>

              {/* Mobile field with icon */}
              <div className="fp-field">
                <span className="fp-icon" aria-hidden>
                  {/* phone icon */}
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M3 5a2 2 0 012-2h3.3a1 1 0 01.95.68l1.5 4.49a1 1 0 01-.5 1.21l-2.26 1.13a11.04 11.04 0 005.52 5.52l1.13-2.26a1 1 0 011.21-.5l4.49 1.5c.4.13.67.5.68.95V19a2 2 0 01-2 2h-1C9.72 21 3 14.28 3 6V5z"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <input
                  type="tel"
                  inputMode="numeric"
                  maxLength={11}
                  className="fp-input"
                  placeholder={t("forgot_password.mobile_placeholder") || "01XXXXXXXXX"}
                  value={mobile}
                  onChange={(e) =>
                    setMobile(e.target.value.replace(/\D/g, "").slice(0, 11))
                  }
                />
              </div>

              {/* Roles */}
              <div className="fp-roles">
                <label className={`fp-radio ${role === "user" ? "is-checked" : ""}`}>
                  <span className="fp-dot" />
                  <input
                    type="radio"
                    value="user"
                    checked={role === "user"}
                    onChange={handleRoleChange}
                    disabled={showOtp || sendingOtp || verifyingOtp}
                  />
                  <span className="fp-radio-label">
                    {t("forgot_password.user_label") || "User"}
                  </span>
                </label>

                <label
                  className={`fp-radio ${role === "servitor" ? "is-checked" : ""}`}
                >
                  <span className="fp-dot" />
                  <input
                    type="radio"
                    value="servitor"
                    checked={role === "servitor"}
                    onChange={handleRoleChange}
                    disabled={showOtp || sendingOtp || verifyingOtp}
                  />
                  <span className="fp-radio-label">
                    {t("forgot_password.servitor_label") || "Servitor"}
                  </span>
                </label>
              </div>

              {errMsg && <div className="fp-error">{errMsg}</div>}

              <div className="fp-actions">
                <button
                  className="fp-btn fp-btn--primary"
                  onClick={handleSendOtp}
                  disabled={sendingOtp || showOtp}
                >
                  {sendingOtp
                    ? t("forgot_password.sending") || "Sending..."
                    : t("forgot_password.send_otp_button") || "Send OTP"}
                </button>
                <button className="fp-btn fp-btn--ghost" onClick={onClose}>
                  {t("forgot_password.cancel_button") || "Cancel"}
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="fp-header">
                <h2>{t("forgot_password.header_reset") || "Reset Password"}</h2>
                <p className="fp-desc">
                  {t("forgot_password.reset_instruction") ||
                    "Enter your new password below to complete the reset process."}
                </p>
              </div>

              {/* New password */}
              <div className="fp-field">
                <span className="fp-icon" aria-hidden>
                  {/* lock icon */}
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 15v2M6 20h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zM16 10V7a4 4 0 10-8 0v3"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <input
                  type={showPass1 ? "text" : "password"}
                  className="fp-input"
                  placeholder={
                    t("forgot_password.new_password_placeholder") || "New Password"
                  }
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="fp-eye"
                  onClick={() => setShowPass1((v) => !v)}
                  aria-label="Toggle password visibility"
                >
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </button>
              </div>

              {/* Confirm password */}
              <div className="fp-field">
                <span className="fp-icon" aria-hidden>
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 15v2M6 20h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zM16 10V7a4 4 0 10-8 0v3"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <input
                  type={showPass2 ? "text" : "password"}
                  className="fp-input"
                  placeholder={
                    t("forgot_password.confirm_password_placeholder") ||
                    "Confirm Password"
                  }
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                <button
                  type="button"
                  className="fp-eye"
                  onClick={() => setShowPass2((v) => !v)}
                  aria-label="Toggle confirm password visibility"
                >
                  <svg viewBox="0 0 24 24" fill="none">
                    <path
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" />
                  </svg>
                </button>
              </div>

              {errMsg && <div className="fp-error">{errMsg}</div>}

              <div className="fp-actions">
                <button
                  className="fp-btn fp-btn--primary"
                  onClick={handleChangePassword}
                  disabled={changingPass}
                >
                  {changingPass
                    ? t("forgot_password.changing") || "Changing..."
                    : t("forgot_password.change_password_button") ||
                      "Change Password"}
                </button>
                <button className="fp-btn fp-btn--ghost" onClick={onClose}>
                  {t("forgot_password.cancel_button") || "Cancel"}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      {/* OTP Modal — unchanged, reuses your styles */}
      {showOtp && (
        <div className="servitorsignupotp-overlay">
          <div className="servitorsignupotp-modal" onClick={(e) => e.stopPropagation()}>
            <div className="servitorsignupotp-header">
              <div className="servitorsignupotp-header-content">
                <div className="servitorsignupotp-icon-container">
                  <div className="servitorsignupotp-icon-bg">
                    <svg className="servitorsignupotp-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                    </svg>
                  </div>
                  <div className="servitorsignupotp-pulse-ring" />
                </div>
                <div>
                  <h2 className="servitorsignupotp-title">
                    {t("forgot_password.otp_title") || "Verify Your Phone"}
                  </h2>
                  <p className="servitorsignupotp-sub">
                    {t("forgot_password.otp_sub", { mobile }) || `Enter the 6-digit code sent to ${mobile}`}
                  </p>
                </div>
              </div>
              <button className="servitorsignupotp-close" onClick={() => setShowOtp(false)}>
                <svg className="servitorsignupotp-close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="servitorsignupotp-body">
              <div className="servitorsignupotp-input-section">
                <label className="servitorsignupotp-label">
                  {t("forgot_password.otp_label") || "Verification Code"}
                </label>
                <div className="servitorsignupotp-inputs">
                  {otpDigits.map((d, idx) => (
                    <input
                      key={idx}
                      type="text"
                      inputMode="numeric"
                      autoComplete={idx === 0 ? "one-time-code" : undefined}
                      maxLength="1"
                      className="servitorsignupotp-input"
                      value={d}
                      onChange={(e) => handleOtpChange(e, idx)}
                      onKeyDown={(e) => handleOtpKeyDown(e, idx)}
                      onPaste={(e) => handleOtpPaste(e, idx)}
                      onFocus={(e) => e.target.select()}
                      autoFocus={idx === 0}
                      data-index={idx}
                      disabled={verifyingOtp || sendingOtp}
                    />
                  ))}
                </div>
              </div>

              {otpErr && <div className="servitorsignup-inline-error">{otpErr}</div>}

              <div className="servitorsignupotp-timer-section">
                <div className="servitorsignupotp-timer-content">
                  <svg className="servitorsignupotp-timer-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="servitorsignupotp-timer-text">
                    {otpSeconds > 0
                      ? (t("forgot_password.otp_timer", { seconds: otpSeconds }) || `Resend code in ${otpSeconds}s`)
                      : (t("forgot_password.otp_no_code") || "Didn't receive the code?")}
                  </span>
                </div>
                {otpSeconds === 0 && (
                  <button className="servitorsignupotp-resend" onClick={resendOtp} disabled={sendingOtp || verifyingOtp}>
                    {t("forgot_password.otp_resend") || "Resend Code"}
                  </button>
                )}
              </div>

              <div className="servitorsignupotp-actions">
                <button
                  className="servitorsignupotp-verify-btn"
                  onClick={() => verifyOtp(otpDigits.join(""))}
                  disabled={verifyingOtp || sendingOtp || !otpDigits.every((d) => d.length === 1)}
                >
                  {verifyingOtp
                    ? t("forgot_password.otp_verifying") || "Verifying..."
                    : t("forgot_password.otp_verify") || "Verify Code"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success modal */}
      {showSuccess && (
        <div className="fp-success-overlay">
          <div className="fp-success-card">
            <div className="fp-success-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path d="M5 13l4 4L19 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <h3>{t("forgot_password.success_title") || "Password Reset Successfully!"}</h3>
            <p className="fp-success-sub">
              {t("forgot_password.success_sub") || "Your password has been updated. You can now sign in with your new password."}
            </p>
            <button className="fp-btn fp-btn--primary" onClick={onClose}>
              {t("forgot_password.back_to_login") || "Back to Login"}
            </button>

             <p className="fp-countdown">
              {t("forgot_password.redirect_in", { seconds: successSeconds }) || `Redirecting to login in ${successSeconds}s`}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default ForgetPassword;
